import { defineMessages } from "react-intl";

import {
	hasDiseaseMessages,
	metastasesMessages,
	nodesMessages,
	treatmentMessages,
	tumourMessages,
	typeMessages,
	validator
} from "lib/build/forms/ktx/transplantation-screening/medical-history/oncologyDiseases";

import { FieldData, FieldsetData } from "src/features/forms";
import { genericErrorMessages } from "src/messages/generic";
import { LeafNode } from "src/modules/shared/form-explorer";

const messages = defineMessages({
	empty: {
		id: "ktx.form.oncologyDisease.emtpy",
		defaultMessage: ""
	},
	hasDisease: {
		id: "ktx.form.oncologyDisease.hasDisease",
		defaultMessage: "Onkológiai betegség?"
	},
	oncologyDisease: {
		id: "ktx.form.oncologyDisease.title",
		defaultMessage: "Onkológiai betegség"
	},
	type: {
		id: "ktx.form.oncologyDisease.type",
		defaultMessage: "Típusa"
	},
	tumour: {
		id: "ktx.form.oncologyDisease.tumour",
		defaultMessage: "T"
	},
	nodes: {
		id: "ktx.form.oncologyDisease.nodes",
		defaultMessage: "N"
	},
	metastases: {
		id: "ktx.form.oncologyDisease.metastases",
		defaultMessage: "M"
	},
	treatment: {
		id: "ktx.form.oncologyDisease.treatment",
		defaultMessage: "Kezelése"
	}
});

const hasDiseaseField: FieldData = {
	type: "field",
	path: ["hasDisease"],
	label: messages.hasDisease,
	errorMessages: genericErrorMessages,
	input: {
		type: "button-group",
		props: { labels: hasDiseaseMessages }
	}
};

const diseaseTypeField: FieldData = {
	type: "field",
	path: ["type"],
	label: messages.type,
	errorMessages: genericErrorMessages,
	input: {
		type: "select",
		props: { labels: typeMessages }
	}
};

const gradeTumourField: FieldData = {
	type: "field",
	path: ["grade", "tumour"],
	label: messages.tumour,
	errorMessages: genericErrorMessages,
	input: {
		type: "button-group",
		props: { labels: tumourMessages }
	}
};

const gradeNodesField: FieldData = {
	type: "field",
	path: ["grade", "nodes"],
	label: messages.nodes,
	errorMessages: genericErrorMessages,
	input: {
		type: "button-group",
		props: { labels: nodesMessages }
	}
};

const gradeMetastasesField: FieldData = {
	type: "field",
	path: ["grade", "metastases"],
	label: messages.metastases,
	errorMessages: genericErrorMessages,
	input: {
		type: "button-group",
		props: {
			labels: metastasesMessages
		}
	}
};

const treatmentField: FieldData = {
	type: "field",
	path: ["treatment"],
	label: messages.treatment,
	errorMessages: genericErrorMessages,
	input: {
		type: "checkbox-group",
		props: {
			labels: treatmentMessages
		}
	}
};

const fieldset: FieldsetData = {
	rows: [
		{
			columns: [{ width: 12, field: hasDiseaseField }]
		},
		{
			columns: [
				{
					width: 12,
					field: {
						type: "field-group-list",
						path: ["diseases"],
						label: messages.empty,
						rows: [
							{
								columns: [
									{ width: 12, field: diseaseTypeField }
								]
							},
							{
								columns: [
									{ width: 12, field: gradeTumourField }
								]
							},
							{
								columns: [{ width: 12, field: gradeNodesField }]
							},
							{
								columns: [
									{ width: 12, field: gradeMetastasesField }
								]
							},
							{
								columns: [{ width: 12, field: treatmentField }]
							}
						]
					}
				}
			]
		}
	]
};

export const node: LeafNode = {
	id: "ktx_oncologyDiseases",
	value: {
		schemaId: "oncologyDiseases",
		title: messages.oncologyDisease,
		validator,
		fieldset,
		applyCurrentDate: true,
		initialValue: { diseases: [{}] }
	}
};
